// base64url → ArrayBuffer
const base64ToArrayBuffer = (b64) => {
    const bin = atob(b64.replace(/-/g, '+').replace(/_/g, '/'));
    const buf = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
    return buf.buffer;
};

// Import the SPKI public key for RSASSA-PKCS1-v1_5/SHA-256
export const importSPAPublicKey = async (pem) => {
    const b64 = pem.replace(/-----.*?-----/g, '').replace(/\s+/g, '');
    const der = base64ToArrayBuffer(b64);
    return crypto.subtle.importKey('spki', der, { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-256' }, false, ['verify']);
};

// Verify JWT signature, parse payload
export const verifyJWT = async (token, publicKey) => {
    const [h, p, s] = token.split('.');
    const data = new TextEncoder().encode(`${h}.${p}`);
    const sig = base64ToArrayBuffer(s);
    const valid = await crypto.subtle.verify('RSASSA-PKCS1-v1_5', publicKey, sig, data);
    const payload = JSON.parse(atob(p.replace(/-/g, '+').replace(/_/g, '/')));
    return { valid, payload };
};
